<template>
  <div class="detection-control-wrap">
    <start-button @switch="emitStart" :loading="loading" :status="status" />
  </div>
</template>

<script>
import StartButton from './start-btn.vue';

export default {
  name: 'VPDetectionControl',
  components: {
    StartButton
  },
  inject: ['calc'],
  props: {
    status: {
      type: String,
      default: 'stop'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitStart(status) {
      this.$emit('update:status', status);
      this.$emit('click', status);
    }
  }
};
</script>

<style lang="scss" scoped>
.detection-control-wrap {
  position: relative;
  width: 100%;
  padding-bottom: 51%;
}
</style>
